import { Button, Modal } from "@alpacahq/ui/old";

type Props = {
  isOpen: boolean;
  isLocked: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedRowsCount: number;
};
export const CancelOrdersModal = ({
  isOpen,
  isLocked,
  selectedRowsCount,
  onConfirm,
  onClose,
}: Props) => {
  return (
    <Modal
      size="sm"
      title="Warning"
      isOpen={isOpen}
      onClose={onClose}
      controls={
        <div className="flex flex-row gap-3">
          <Button variant="ghost" onClick={onClose}>
            Nevermind
          </Button>
          <Button
            onClick={onConfirm}
            disabled={selectedRowsCount === 0 || isLocked}
          >
            Confirm
          </Button>
        </div>
      }
    >
      <p>Are you sure you want to cancel {selectedRowsCount} order(s)?</p>
      <br />
      <p>This action cannot be undone.</p>
    </Modal>
  );
};
